'use client';

import React from 'react';
import { Modal } from '@/app/components/ui/Modal';
import { Button } from '@/app/components/ui/Button';
import { CheckCircle } from 'lucide-react';

interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PaymentSuccessModal = ({
  isOpen,
  onClose,
}: PaymentSuccessModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Payment Successful"
    >
      <div className="flex flex-col items-center text-center space-y-6 py-2">
        <div className="w-16 h-16 bg-teal/10 rounded-full flex items-center justify-center">
          <CheckCircle className="w-8 h-8 text-teal" />
        </div>
        
        <p className="text-lg text-gray-600">
          We will email you your order id shortly.
        </p>

        <Button 
          onClick={onClose}
          className="w-full"
          size="lg"
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

